import styled from 'styled-components'

const WrapSectionHeader = styled.div`
  margin-bottom: 1rem;
  min-height: 12rem;
  #title {
    text-decoration-line: underline;
  }
  #header {
    font-weight: bold;
  }
  #value {
    font-weight: 100;
  }
`

export { WrapSectionHeader }
